import React, { useContext, useEffect, useState } from "react";
import CommonNavBar from "components/InterstellrComponents/CommonNavBar";
import Footer from "components/InterstellrComponents/CommonFooter";
import Recipes from "components/Recipes/Recipes";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { GET_ADMIN_PROFILE } from "URLRoutes";
import { generateURLOptions } from "URLOptions";
import { UserContext } from "providers/UserProvider";
import Mindfulness from "components/Mindfulness/Mindfulness";
import Exercises from "components/Exercises/Exercises";
import VirtualCommute from "components/VirtualCommute/VirtualCommute";
import Users from "components/Users/Users";
import Dashboard from "components/dashboard";
import Businesses from "components/Businesses/Businesses";
import AppReports from "components/AppReports/AppReports";
import EventBus from "providers/EventBus";

const MainLayout = () => {
  const { profile, setProfile } = useContext(UserContext);
  const navigate = useNavigate();
  const [currentState, setCurrentState] = useState("Dashboard");

  const updateAdminProfile = async () => {
    try {
      const { data } = await axios.get(GET_ADMIN_PROFILE, {
        headers: generateURLOptions(),
      });

      // API-level failure (non-401)
      if (data?.success === false) {
        alert(data?.message ?? "");
        navigate("/login");
        return;
      }

      setProfile(data?.data);
    } catch (error) {
      const status = error?.response?.status;

      // Silent redirect on auth failure
      if (status === 401) {
        setProfile(null);
        navigate("/");
        return;
      }

      // Optional: log or handle other errors
      console.error(error);
    }
  };

  const updateRoute = (route) => {
    setCurrentState(route);
  };

  useEffect(() => {
    updateAdminProfile();

    EventBus.on("changeRoute", updateRoute);

    return () => {
      EventBus.off("changeRoute", updateRoute);
    };
  }, []);

  return (
    <>
      <div className="flex flex-row">
        <CommonNavBar currentState={currentState} onChange={setCurrentState} />

        {/* Conditionally render the correct view based on the user */}

        <div className="w-4/5">
          {/* Recipes */}
          {currentState == "Dashboard" ? <Dashboard /> : null}
          {currentState == "Users" ? <Users /> : null}
          {currentState == "Organisations & Groups" ? <Businesses /> : null}
          {currentState == "Recipes" ? <Recipes /> : null}
          {currentState == "Exercise Routines" ? <Exercises /> : null}
          {currentState == "Virtual Commute" ? <VirtualCommute /> : null}
          {currentState == "Mindfulness" ? <Mindfulness /> : null}
          {currentState == "App Reports" ? <AppReports /> : null}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MainLayout;
